/*
 * This file waits until the document loads and binds an on-click event to each List Your Property link.
 * This is required because the XDID cookies takes up to 5 seconds to be populated and the List Your
 * Property button requires the cookie value uuid to be sent along in a query parameter.
 * The XDID value is required on the next application which does server side bucketing for tests.
 */
import { addXdidToElementHref } from './utils/xdid';

export function initLypOnClick() {
  // Catch links in all environments
  document.querySelectorAll('[href="https://www.expediapartnercentral.com/list"],[href="http://expediapartnercentral.com.sb.karmalab.net/list"]').forEach((element) => {
    element.addEventListener('click', e => addXdidToElementHref(e));
  });
}
